const NameContext = React.createContext(null);
export const NameProvider = NameContext.Provider;
export function useName(name) {
    const providedName = React.useContext(NameContext);
    return providedName && name
        ? providedName + '.' + name
        : providedName || name;
}
